<ion-app>
  <ion-split-pane when="md" contentId="main">
    <ion-menu class="menu" contentId="main">
      <app-menu [version]="versionInfo" class="h-full"></app-menu>
    </ion-menu>
    <ion-router-outlet id="main"></ion-router-outlet>
  </ion-split-pane>
</ion-app>